import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../elements/Button'
import Dropdown from '../../elements/dropdown'
import DropdownItem from '../../elements/dropdown/dropdown-item'
import RestaurantLogo from '../../elements/RestaurantLogo'
import InputFill from '../../form/InputFill'
import InputSelect from '../../form/InputSelect'

const SearchLocation = ({
    address,
    setAddress,
    error,
    setError,
    listLocation,
    handleCalcDistance,
    handleSubmit,
    openLoginForm,
    userAddress,
    handleSelectAddress,
}) => {
    const { t } = useTranslation()

    return (
        <form
            onSubmit={handleSubmit}
            className="text-center modal-method__search"
        >
            <RestaurantLogo width="120px" className="logo-restaurant mt-6" />

            <div className="mt-6 modal-method__title">
                {t('modalOrderMethod.titleSearchAddress')}
            </div>

            <Dropdown
                widthFull
                forceClickOpen
                toggleButton={
                    <InputFill
                        error={error}
                        onFocus={() => setError('')}
                        value={address}
                        onChange={({ target: { value } }) => setAddress(value)}
                        className="mt-6"
                    />
                }
                position="bottom center"
                dropdownClass="dropdown-location"
                dropdownListClass="dropdown-location__list"
            >
                {listLocation.map(loca => (
                    <DropdownItem
                        key={loca.place_id}
                        widthAuto
                        className="text-left"
                        onClick={() => handleCalcDistance(loca)}
                    >
                        {loca.description}
                    </DropdownItem>
                ))}
            </Dropdown>

            {!!userAddress?.length && (
                <div className="mt-4">
                    <InputSelect
                        label={t('modalOrderMethod.lbAddressSaved')}
                        onChange={handleSelectAddress}
                        value=""
                        options={[
                            <option disabled hidden key="opt-default" value="">
                                {t('customerInfo.lbDefaultSelectAddress')}
                            </option>,
                            ...userAddress.map((address, index) => (
                                <option key={index} value={index}>
                                    {[
                                        `${address.street} ${address.addressNumber}`,
                                        `${address.zipCode} ${address.city}`,
                                        address.floor,
                                    ]
                                        .filter(Boolean)
                                        .join(', ')}
                                </option>
                            )),
                        ]}
                    />
                </div>
            )}

            <Button outline className="mt-6">
                {t('modalOrderMethod.btnNext')}
            </Button>

            {!userAddress && (
                <div className="mt-6 have-an-account">
                    {t('modalOrderMethod.lbHadAccount')}
                    <a className="ml-1" href="#" onClick={openLoginForm}>
                        {t('button.login')}
                    </a>
                </div>
            )}
        </form>
    )
}

export default SearchLocation
